import { useCallback } from 'react';
import { useSnackbar, VariantType, OptionsObject } from 'notistack';

export default function useNotification() {
  const { enqueueSnackbar } = useSnackbar();

  const showMessage = useCallback(
    (message: string, variant: VariantType, extra: OptionsObject = {}) => {
      try {
        enqueueSnackbar(message, {
          variant,
          anchorOrigin: {
            vertical: 'top',
            horizontal: window.innerWidth >= 600 ? 'center' : 'right',
          },
          ...extra,
        });
      } catch (e) {
        console.warn('showMessageError', e);
      }
    },
    [enqueueSnackbar],
  );
  return showMessage;
}
